/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Ac_1Inputs */

const en_pc_cmp_ac_1 = /** @type {(inputs: Pc_Cmp_Ac_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need to edit the existing text or images inside a PDF.`)
};

const zh_pc_cmp_ac_1 = /** @type {(inputs: Pc_Cmp_Ac_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要修改 PDF 中已有的文字或图片。`)
};

/**
* | output |
* | --- |
* | "You need to edit the existing text or images inside a PDF." |
*
* @param {Pc_Cmp_Ac_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_ac_1 = /** @type {((inputs?: Pc_Cmp_Ac_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Ac_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_ac_1(inputs)
	return zh_pc_cmp_ac_1(inputs)
});
export { pc_cmp_ac_1 as "pc.cmp.ac.1" }